import React from 'react';
import SuggestionListTable from './SuggestionListTable';

/**
 * FoodLabelSuggestionsPage - Wrapper for food label suggestions (isLabelFood=true)
 * Displays barcode-scanned food label suggestions
 */
const FoodLabelSuggestionsPage = () => {
  return (
    <SuggestionListTable
      type="foodLabel"
      title="Food Label Suggestions"
      description="Review and manage food suggestions from barcode scans and food labels"
      basePath="/suggestions/labels"
    />
  );
};

export default FoodLabelSuggestionsPage;
